import { useSettings } from './queries'
import type { Textgrenzen } from '../api/types'

/**
 * Die Zahlen, wenn der Server sie (noch) nicht genannt hat.
 *
 * **Ein Rückfall und keine zweite Wahrheit.** Er greift in genau zwei Fällen:
 * die Abfrage ist noch unterwegs, oder es läuft eine ältere Serverversion, die
 * `text_limits` nicht mitschickt. In beiden Fällen ist ein Zähler mit einer
 * plausiblen Zahl besser als gar keiner — und wenn er danebenliegt, lehnt der
 * Server ab und sagt die richtige Zahl.
 *
 * Die Werte sind bewusst **die heutigen Vorgaben** und nicht kleiner:
 * ein zu enger Rückfall wäre eine Sperre, die der Server gar nicht kennt.
 */
export const TEXTGRENZEN_NOTFALL: Textgrenzen = {
  message: 8000,
  highlight: 16000,
  spot_note: 500,
  trip_description: 2000,
  title: 120,
  playlist_note: 200,
  day_separator_note: 300,
  maintenance_text: 300,
}

/**
 * Wie lang ein Text sein darf — vom Server, sonst aus dem Rückfall.
 *
 * Liegt auf `useSettings()` und kostet damit keine zweite Abfrage: die
 * Einstellungen holt ohnehin fast jede Seite.
 */
export function useTextgrenzen(): Textgrenzen {
  const settings = useSettings()
  return settings.data?.text_limits ?? TEXTGRENZEN_NOTFALL
}
